export const DAY = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
} as const

export const DAYS_WITH_NUMBERS = {
  [DAY.MONDAY]: 1,
  [DAY.TUESDAY]: 2,
  [DAY.WEDNESDAY]: 3,
  [DAY.THURSDAY]: 4,
  [DAY.FRIDAY]: 5,
  [DAY.SATURDAY]: 6,
  [DAY.SUNDAY]: 7,
} as const

export const DAYS = Object.values(DAY)
export const NUM_DAYS_WEEK = DAYS.length
